import { ReactNode } from 'react';
import { MapBounds } from '../../graphql/graphql';
import { getShrunkBoundsFromMap } from '../../utils/helpers/map';

export type Marker = {
  id: string;
  type: 'ClusterMapMarker' | 'ItemMapMarker';
  position: { lat: number; lng: number };
  label: string | ReactNode;
  itemsIds?: string[];
};

export interface ItemsMapProps {
  title: string;
  zoom?: number;
  map: google.maps.Map | null;
  mapBounds?: MapBounds | null;
  mapMarkers?: Marker[];
  activeSelection: Marker | null;
  setMap: React.Dispatch<React.SetStateAction<google.maps.Map | null>>;
  setZoom: React.Dispatch<React.SetStateAction<number | undefined>>;
  setActiveSelection: React.Dispatch<React.SetStateAction<Marker | null>>;
  children: ReactNode;
  onBoundsChange?: (
    value: ReturnType<typeof getShrunkBoundsFromMap> | null
  ) => void;
}

export enum MapViewQueryParam {
  itemsView = 'items_view',
  residencesView = 'residences_view'
}

export enum MapViewMode {
  map = 'map',
  list = 'list'
}
